import GroupIcon from '@mui/icons-material/Group';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Icon from 'common/components/Elements/Icon/Icon';
import * as I from 'core/api/coreApiClient';
import theme from 'core/utilities/theme';
import React from 'react';

export type TooltipHelp = string | I.ChoiceInfo;

interface ComponentProps {
  tooltipHelp: TooltipHelp;
}

function InputTooltipHelp({ tooltipHelp }: ComponentProps) {
  let title = '';
  let element = HelpOutlineIcon;

  if (typeof tooltipHelp === 'string') {
    title = tooltipHelp;
  } else if (tooltipHelp) {
    title = tooltipHelp.title || '';
    if (tooltipHelp.choiceInfoType === I.ChoiceInfoTypeConstants.UserGroupsFilterActive) {
      element = GroupIcon;
    }
  }

  return (
    <Tooltip title={title} placement="top">
      <IconButton
        aria-label="input text help"
        size="small"
        style={{ marginLeft: theme.spacing(0.5) }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Icon element={element} />
      </IconButton>
    </Tooltip>
  );
}

export default InputTooltipHelp;
